module.exports = __webpack_public_path__ + "img/s-mob-8.240a4e65.webp";